import { ProductSliderMedia } from '../../media'

import { Slider } from './slider/slider'

import cl from './detailed-slider.module.scss'

type DetailedSliderProps = {
	media?: ProductSliderMedia[]
	activeSlide?: number
}

export const DetailedSlider = (props: DetailedSliderProps) => {
	const { media = [], activeSlide } = props

	return (
		<div className={cl.root}>
			<div className={cl.root__slider}>
				<Slider media={media} activeIndex={activeSlide} />
			</div>
		</div>
	)
}
